import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ExperienceSection from './components/ExperienceSection';
import Collections from './pages/Collections';
import Footer from './components/Footer';
import ProductModal from './components/ProductModal';
import './styles/global.css';

function App() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    const handleProductSelect = (product) => {
        setSelectedProduct(product);
    };

    const handleCloseModal = () => {
        setSelectedProduct(null);
    };

    return (
        <div className="app">
            <Header />
            <main>
                <div id="home">
                    <Hero onExploreClick={() => document.getElementById('collections').scrollIntoView({ behavior: 'smooth' })} />
                </div>
                <ExperienceSection />
                <Collections onProductSelect={handleProductSelect} />
            </main>
            <Footer />

            <ProductModal
                product={selectedProduct}
                onClose={handleCloseModal}
            />
        </div>
    );
}

export default App;
